module.exports = __webpack_public_path__ + "img/mobile_map_blufi.4902e00a.svg";